import idMessages from '../locales/id_ID.json';
import idID from 'antd/lib/locale/id_ID';

const idLang = {
  messages: {
    ...idMessages,
  },
  antLocale: idID,
  locale: 'id-ID',
};
export default idLang;
